var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'View Warehouse', params: { id: _vm.warehouse.id } }}},[_vm._v(" "+_vm._s(`${_vm.warehouse.name}`)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }